import AdminLeadershipBonuses from "./Admin/AdminLeadershipBonuses.jsx";
import AgentLeadershipBonuses from "./Agent/AgentLeadershipBonuses.jsx";
import { isFieldAgent } from "../../utils/roleDetection";

const LeadershipBonuses = () => {
	const stored = localStorage.getItem("loggedin_data");
	const user = stored ? JSON.parse(stored) : null;
	const roles = Array.isArray(user?.roles) ? user.roles : [];
	const isAgent = isFieldAgent(roles);

	return isAgent ? <AgentLeadershipBonuses /> : <AdminLeadershipBonuses />;
};

export default LeadershipBonuses;
